import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import { IconButton, Tooltip } from '@mui/material';
import React from 'react';
import { useMode } from '../../contexts';

const ModeSwitcher: React.FC = () => {
  const { mode, setMode } = useMode();

  return (
    <Tooltip
      title={mode === 'dark' ? 'Toggle Light' : 'Toggle Dark'}
      placement="top"
    >
      <IconButton
        color="inherit"
        size="small"
        sx={{ marginRight: 1, marginTop: 0 }}
        onClick={() => setMode(mode === 'dark' ? 'light' : 'dark')}
      >
        {mode === 'dark' ? (
          <LightModeIcon onClick={() => setMode('light')} />
        ) : (
          <DarkModeIcon onClick={() => setMode('dark')} />
        )}
      </IconButton>
    </Tooltip>
  );
};

export default ModeSwitcher;
